import { connectPagination } from 'react-instantsearch-dom';
import { Pagination, Row, Col } from 'react-bootstrap';
import { ComponentType, useMemo } from 'react';
import calculateThePagesToShowOnPagination from './utils/calculateThePagesToShowOnPagination';

type Props = {
  currentRefinement: number;
  nbPages: number;
  refine: (...args: any[]) => any;
  createURL: (page: string | number) => string;
};

export const CustomPagination: ComponentType<Props> = ({
  nbPages,
  currentRefinement,
  refine,
  createURL,
}) => {
  const isFirstPage = currentRefinement === 1;

  const isLastPage = currentRefinement === nbPages;

  const pagesToDisplay = useMemo(
    () => calculateThePagesToShowOnPagination(currentRefinement, nbPages),
    [nbPages, currentRefinement],
  );

  if (nbPages < 2) {
    return null;
  }

  return (
    <Row>
      <Col className="text-center pt-4">
        <Pagination className="justify-content-center">
          {!isFirstPage && (
            <Pagination.Prev
              onClick={(e) => {
                e.preventDefault();
                refine(currentRefinement - 1);
              }}
            />
          )}
          {pagesToDisplay.map((value) => {
            if (value < 1) {
              return <Pagination.Ellipsis key={value} />;
            }

            const page = value;
            const url = createURL(page);
            return (
              <Pagination.Item
                active={page === currentRefinement}
                key={page}
                href={page === currentRefinement ? undefined : url} // Avoids span tag with href for current page
                onClick={(e) => {
                  e.preventDefault();
                  refine(page);
                }}
              >
                {page}
              </Pagination.Item>
            );
          })}
          {!isLastPage && (
            <Pagination.Next
              onClick={(e) => {
                e.preventDefault();
                refine(currentRefinement + 1);
              }}
            />
          )}
        </Pagination>
      </Col>
    </Row>
  );
};

const AlgoliaPagination = connectPagination(CustomPagination);

export default AlgoliaPagination;
